import { Col, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import IncentiveContext from "../../../context/incentive/context";
import DriverClassificationContext from "../../../context/driver-classification/context";
import Form from "../../form-components/from";
import { INITIAL_PAGE } from "../../../utils/helpers/constants";
import FieldBuilder from "../../form-components/field-builder";

interface IProps {}

const IncentiveFilter: React.FC<IProps> = () => {
  const { t } = useTranslation();
  const { actions, query } = useContext(IncentiveContext);
  const driverClassificationContext = useContext(DriverClassificationContext);
  const [driverClassificationOptions, setDriverClassificationOptions] = useState<any[]>([]);

  const statusOptions = [
    { label: t("active"), value: 1 },
    { label: t("inactive"), value: 2 },
  ];

  useEffect(() => {
    driverClassificationContext.actions.getData();
  }, []);

  useEffect(() => {
    if (driverClassificationContext.list?.data) {
      const options = driverClassificationContext.list.data.map((item) => ({
        label: item.name,
        value: item.id,
      }));
      setDriverClassificationOptions(options);
    }
  }, [driverClassificationContext.list]);

  return (
    <Form
      formId="incentive-filter"
      onSubmit={(data) => {
        const filter: any = {
          page: INITIAL_PAGE,
          perPage: query?.perPage,
          keyword: data?.keyword,
          filters: [
            data?.status !== undefined && data?.status !== null
              ? {
                  name: "status",
                  value: data.status,
                  operation: "eq",
                }
              : undefined,
            data?.driverClassificationId !== undefined && data?.driverClassificationId !== null
              ? {
                  name: "driverClassificationId",
                  value: data.driverClassificationId,
                  operation: "eq",
                }
              : undefined,
          ].filter((f) => f),
        };
        actions.setQuery(filter);
      }}
    >
      <Row justify={"start"} gutter={[10, 0]}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="status"
            label={`${t("status")}`}
            width="large"
            input={{
              type: "select",
              options: statusOptions,
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={12}>
          <FieldBuilder
            name="driverClassificationId"
            label={`${t("driver_classification")}`}
            width="large"
            input={{
              type: "select",
              options: driverClassificationOptions,
            }}
          />
        </Col>
      </Row>
    </Form>
  );
};

export default IncentiveFilter;
